









import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { debounce } from '@/utils/helpers/helpFunctions'

interface Data {}

interface Methods {
  onInput: (e: any) => void
  onChange: (e: any) => void
}

interface Computed {}

interface Props {
  debounceWait: number
  value: string
  error: boolean
}

export default Vue.extend({
  name: 'UiTextarea',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: () => ''
    },
    debounceWait: {
      type: Number,
      default: () => 0
    },
    error: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    onInput (e: any): void {
      if (this.debounceWait > 0) {
        debounce(() => {
          this.$emit('input', e.target.value)
        }, this.debounceWait)
        return
      }
      this.$emit('input', e.target.value)
    },
    onChange (e: any): void {
      this.$emit('change', e.target.value)
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
